import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { ModalFooter, ModalBody } from "../../../application/modal";
import { appModelSettingSet } from "application/app.action";
import {
  Button, BtnType, Label, MultiSelect,
} from "../../primitives";
import styles from "./selectUser.module.scss";
import { councilUsersListGet } from "../../../common/actions/common.action";

const SelectUserComponent = (props) => {
  const dispatch = useDispatch();
  const [selected, setSelected] = useState([]);
  const [options, setOptions] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  const { callBack } = props;
  const {
    appReducer: { modalSetting },
    councilReducer: { usersList, selectedCouncil },
  } = useSelector((state) => state);

  const handleCancelClick = (e) => {
    dispatch(appModelSettingSet({ ...modalSetting, show: false }));
  };

  useEffect(() => {
    if (selectedCouncil) {
      dispatch(councilUsersListGet(selectedCouncil.id, enqueueSnackbar));
    }
  }, [selectedCouncil]);

  useEffect(() => {
    if (usersList && usersList.length !== 0) {
      const list = usersList.map((user) => ({
        id: user.id,
        fullName: `${user.first} ${user.last}`,
      }));
      setOptions(list);
    }
  }, [usersList]);

  const handleSaveClick = (e) => {
    callBack(selected);
    dispatch(appModelSettingSet({ ...modalSetting, show: false }));
  };

  const handleOptionSelect = (values) => {
    setSelected(...values);
  };

  return (
    <div className={styles.selectCouncilWrp}>
      <ModalBody>
        <Label>Users</Label>
        <MultiSelect
          onChange={handleOptionSelect}
          placeholder="User"
          labelField="fullName"
          valueField="id"
          searchBy="fullName"
          options={options}
          multi={null}
          className={null}
        />
      </ModalBody>
      <ModalFooter>
        <Button btn={BtnType.FRAME_LESS} onClick={handleCancelClick}>
          Cancel
        </Button>
        <Button type="submit" btn={BtnType.REGULAR} onClick={handleSaveClick}>
          Save
        </Button>
      </ModalFooter>
    </div>
  );
};

export default React.memo(SelectUserComponent);
